<div class="absolute top-0 left-0 z-10 opacity-50">
  <div
    *ngFor="let star of stars"
    class="star"
    [style.top]="star.top"
    [style.left]="star.left"
    [style.animationDelay]="star.delay"
  ></div>
</div>
